<div *ngIf="permissionAccess">
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-4 border-bottom pb-4 ml-1">
    <div class="mb-3 mb-md-0">
      <h2 class="fw-semibold text-dark mb-1">Archivos por departamento</h2>
      <p class="text-secondary mb-0">Registro de archivos por departamento</p>
    </div>

    <div class="col-sm-12 col-lg-6">
      <div class="d-flex flex-row-reverse">
        <button class="btn btn-primary" (click)="showModal(contenido)">&nbsp;&nbsp;&nbsp; Agregar Archivo
          &nbsp;&nbsp;&nbsp;</button>
      </div>
    </div>
  </div>
  <!-- Modal add file -->
  <div class="align-self-center">
    <ng-template #contenido let-modal let-c="close" style="width: 300px;">

      <div class="modal-header">
        <h1 class="modal-title">Agregar Archivo</h1>
      </div>


      <div class="modal-body" [formGroup]="modalForm">
        <div class="row mt-2">
          <div class="col-sm-12 col-lg-6 form-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descripcion del archivo: </mat-label>
              <input type="text" matInput formControlName="name" required maxlength="30" />
            </mat-form-field>
          </div>

          <div class="col-sm-12 col-lg-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Departamentos</mat-label>
              <mat-select formControlName="department">
                <mat-option class="form-control" *ngFor="let department of departments" [value]="department.id">
                  {{ department.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="col-12">
            <label for="exampleFormControlFile1">Archivo a subir &nbsp; <span class="material-icons"> cloud_upload
              </span>
            </label>
            <input type="file" formControlName="file" name="file" class="form-control" id="exampleFormControlFile1"
              (change)="onFileSelected($event)" accept="application/pdf" required />
          </div>

          <div class="col-lg-6 mt-2">
            <div *ngIf="WarningMsg">
              <h3 style="color:red;">{{WarningMsg}}</h3>
            </div>
          </div>

        </div>

        <div class="row" *ngIf="buttonOn">
          <div class="col-12 mt-2">
            <div class="d-flex flex-row-reverse">
              <button class="btn btn-primary" [disabled]="!modalForm.valid" (click)="saveData()">Guardar
                archivo</button>
              <button class="btn btn-danger mr-2" (click)="modal.dismiss()">Cancelar</button>
            </div>
          </div>
          <div class="col-12 mt-2" *ngIf="load" style="float: right;">
            Cargando...
          </div>

        </div>

      </div>
    </ng-template>
  </div>
  <!-- Modal confirm delete file -->
  <div class="align-self-center">
    <ng-template #contentConfirmDelete let-modal let-c="close" style="width: 200px;">
      <div class="modal-header">
        <h1 class="modal-title">Deseas eliminar el archivo {{fileNameToDelete}} ?</h1>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-6 text-center">
            <button class="btn btn-primary" (click)="closeAnyModal()">Cancelar</button>
          </div>
          <div class="col-6 text-center">
            <button class="btn btn-danger" (click)="deleteFile()">Eliminar</button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="row" *ngFor="let department of departments">
    <div class="col-lg-12">
      <mat-accordion class="align-self-center">
        <mat-expansion-panel hideToggle class="mt-3">
          <mat-expansion-panel-header (click)="getFilesDepartment(department.id)">
            <mat-panel-title> {{department.name}} </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row" style="max-height: 600px ; overflow-y: scroll;">
            <div *ngIf="isDepartmentEmpty(department.id)">
              <h4>No existen archivos de este departamento</h4>
            </div>
            <div *ngFor="let file of filesByDepartment[department.id]">
              <div class="col-lg-3 mt-2">
                <div class="card" style="width: 190px; height: auto;">
                  <img class="card-img-top"
                    src="https://firebasestorage.googleapis.com/v0/b/mrpresta.appspot.com/o/images%2F00.png?alt=media&token=b68e6d7a-ad74-41a8-aa29-654c98089644"
                    style="width:150px; height: 90px; position:relative; left:15px;" class="card-img-top" alt="...">
                  <div class="card-body">
                    <h5 class="card-title">{{file.created_at}}</h5>
                    <p class="card-text">{{file.name}}</p>
                    <div class="row">
                      <div class="col-5">
                        <a href="{{file.signed_url}}" target="_blank" class="btn btn-outline-primary btn-sm ml-0">Abrir
                          <i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>
                      </div>
                      <div class="col-2">
                        <button class="btn btn-outline-danger btn-sm"
                          (click)="showModalConfirmDelete(contentConfirmDelete, file.name, file.url)"><i
                            class="fa fa-trash-o" aria-hidden="true"></i></button>
                      </div>
                    </div>

                  </div>
                  <div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="col-lg-1"></div>
  </div>
</div>
<app-restricted-module-view *ngIf="!permissionAccess"></app-restricted-module-view>